import { gql } from "@apollo/client"

export const GET_PLAYER_STATS = gql`
  query GetPlayerStats($input: UserStatsInput!) {
    UserStats(input: $input) {
      player {
        code
        name
        firstSurname
        lastSurname
        email
        documentNumber
      }
      totals {
        tournaments
        points
        wins
        losses
        draws
        winRate
      }
      games {
        name
        tournaments
        points
      }
      tournamentTypes {
        name
        tournaments
        points
      }
      detailedStats {
        name
        types {
          name
          tournaments
          wins
          losses
          draws
          points
        }
      }
      analyzedSeasons {
        name
        seasons {
          id
          name
          code
          startDate
          endDate
          isActive
        }
      }
      status {
        name
        detail
        success
        code
      }
    }
  }
`
